import React from "react"
import Header from "../components/core/header"
import Footer from "../components/core/footer"
import SEO from "../components/Features/seo"
import image from "../images/logo.png"
import HireMe from "../components/post/hireMe"

import "../styles/index.scss"

const About = () => {
  return (
    <div>
      <Header />

      <div className="bg-white container pb-1 pt-2  mt-5 h-100">
        <SEO
          title="About us | Freelancology"
          image={image}
          slug="about"
          description="The Freelancology is a blog webiste that covers all sorts of News / Shobiz / Sports / Mobile / Packages / new Techniques and Technologies articles. If you have any article you can share us we will post on our website by your name. if you want to promote your business product/page etc contact us."
        />
        <div className="row  h-100 justify-content-center align-items-center">
          <div className="col-md-8 ">
            <div className="pt-0 pl-5 pr-5 pb-0 aboutMobile">
              <h1 className="jazz-feed text-left m-0">About Us</h1>
              <hr className="m-1 p-0" />
              <p className="text-justify">
                The Freelancology is a blog webiste that covers all sorts of
                News / Shobiz / Sports / Mobile / Packages / new Techniques and
                Technologies articles. If you have any article you can share us
                we will post on our website by your name. if you want to promote
                your business product/page etc contact us.
              </p>
              <hr className="m-1 p-0" />
              <h1 className="jazz-feed m-0 text-left">Contact Us</h1>
              <hr className="m-1 p-0" />
              <h5>
                Address:{" "}
                <small className="text-muted">
                  Latifabad Unit 2, Hyderabad, Sindh, Pakistan
                </small>
              </h5>

              <h5>
                Email:{" "}
                <small className="text-muted">info@freelancology.com</small>
              </h5>
              <h5>
                Contact:{" "}
                <small className="text-muted">
                  +923450152988 || +923443099106
                </small>
              </h5>
              <hr className="m-0 p-0" />
            </div>
          </div>
          <div className="col-md-4">
            <HireMe />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default About

// export const AboutAuthor = graphql`
//   query AboutAuthorByAdmin {
//     contentfulBlogPost(author: { name: { eq: "Shahid Ali" } }) {
//       id
//       name
//       shortBio {
//         shortBio
//       }
//       image {
//         fluid(maxWidth: 300) {
//           base64
//           tracedSVG
//           srcWebp
//           srcSetWebp
//         }
//       }
//     }
//   }
// `
